export const GRAPHQL_URL =
  //  'https://stage.api.connect.supergitsa.com/query'

   "https://api.supergitsa.com/query";

export const API_BASE_URL = GRAPHQL_URL.replace(/\/query\/?$/, '/api')
